// src/services/authService.js
import apiClient from "./axiosInterceptor";
import config from "../config";

// Use shared axios client for auth endpoints (includes auth header)
// Base URL already set in axiosInterceptor

// Send reset password email
export const sendResetEmail = async (email) => {
  try {
    const response = await apiClient.post(
      '/users/forgot-password',
      null, // no body
      { params: { email } } // => /users/forgot-password?email=...
    );
    return { ok: true, data: response.data };
  } catch (error) {
    console.error('Error sending reset email:', error);
    if (error.response) {
      return { 
        ok: false, 
        error: error.response.data || error.response.statusText,
        status: error.response.status
      };
    } else if (error.request) {
      return { 
        ok: false, 
        error: 'Network error - please check your connection' 
      };
    } else {
      return { 
        ok: false, 
        error: error.message || 'An unexpected error occurred' 
      };
    }
  }
};

// Verify OTP
export const verifyOtp = async (email, code) => {
  try {
    const response = await apiClient.post('/users/check-otp', null, {
      params: { email, otp: code },
    });

    const resData = response.data || {};

    const maybeToken =
      (resData.data && (resData.data.reset_token || resData.data.token)) ||
      resData.reset_token ||
      resData.token ||
      null;

    return {
      ok: !!resData.success,
      data: resData,
      reset_token: maybeToken,
      message: resData.message || null,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      return {
        ok: false,
        error: error.response.data?.message || error.response.data || error.response.statusText,
        status: error.response.status,
      };
    } else if (error.request) {
      return { ok: false, error: 'Network error - please check your connection' };
    }
    return { ok: false, error: error.message || 'An unexpected error occurred' };
  }
};

// Reset password
export const resetPassword = async (email, newPassword, resetToken) => {
  try {
    const response = await apiClient.post(
      '/users/reset-password',
      null, // no body
      { 
        params: { 
          email: email,
          new_password: newPassword,
          reset_token: resetToken
        } 
      }
    );
    
    if (response.data.success) {
      return { 
        ok: true, 
        data: response.data 
      };
    } else {
      return { 
        ok: false, 
        error: response.data.message || 'Failed to reset password',
        status: response.status 
      };
    }
  } catch (error) {
    console.error('Error resetting password:', error);
    if (error.response) {
      return { 
        ok: false, 
        error: error.response.data?.message || error.response.data || error.response.statusText,
        status: error.response.status
      };
    } else if (error.request) {
      return { 
        ok: false, 
        error: 'Network error - please check your connection' 
      };
    } else {
      return { 
        ok: false, 
        error: error.message || 'An unexpected error occurred' 
      };
    }
  }
};
